export default "__VITE_ASSET__0nB$ouOm__"